import React, { FC } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Theme,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import MenuIcon from "@mui/icons-material/Menu";
import { NavLink } from "react-router-dom";
import { RoleAction } from "../../../enums/permission-actions";
import useUserPermissions from "../../../hooks/user-permissions";

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    flexGrow: 1,
  },
  navItem: {
    ...theme.typography.button,
    variant: "contained",
    color: "primary",
    margin: "0 8px",

    "&.active": {
      color: "black",
      fontWeight: "bold",
      textDecoration: "none",
    },
    "&.active > span": {
      borderBottom: "2px solid #D27519", // + theme.palette.secondary.main,
    }
  },
}));

const NavMenu: FC = () => {
  const classes = useStyles();

  const [isViewRecordsMgmtDisabled] = useUserPermissions(RoleAction.VIEW_RECORDS_MGMT);
  const [isViewMajorEventsDisabled] = useUserPermissions(RoleAction.VIEW_MAJOR_EVENTS);

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <>
      <IconButton
        size="large"
        aria-label="VCC Navigation Menu"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleOpenNavMenu}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorElNav}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(anchorElNav)}
        onClose={handleCloseNavMenu}
      >
        <Box m={1} pt={0.5} className={classes.title}>
          <MenuItem
            disableRipple
            component={NavLink}
            className={classes.navItem}
            to="/feed"
            onClick={handleCloseNavMenu}
          >
            <span>Feed</span>
          </MenuItem>
          <Divider />
          {!isViewRecordsMgmtDisabled && (
            <>
              <MenuItem
                disableRipple
                component={NavLink}
                className={classes.navItem}
                to={"/records-management"}
                onClick={handleCloseNavMenu}
              >
                <span>Records Management</span>
              </MenuItem>
              <Divider />
            </>
          )}
          {!isViewMajorEventsDisabled && (
            <>
              <MenuItem
                disableRipple
                component={NavLink}
                className={classes.navItem}
                to={"/event-management"}
                onClick={handleCloseNavMenu}
              >
                <span>Construction & Events</span>
              </MenuItem>
              <Divider />
            </>
          )}
          <MenuItem
            disableRipple
            component={NavLink}
            className={classes.navItem}
            to={"/dashboard"}
            onClick={handleCloseNavMenu}
          >
            <span>Dashboard</span>
          </MenuItem>
        </Box>
      </Menu>
    </>
  )
}

export default NavMenu;